import React, { Component } from 'react'

import CSSModules from 'react-css-modules'
import _ from 'lodash'

import Input from 'components/fulcrum/input/Input'
import Dropdown from 'components/fulcrum/dropdown/FulcrumDropdown'

import FormTitle from 'components/fulcrum/formTitle/FormTitle'
import styles from './styles.scss'

import T from 'i18n-react' 
import {
  PROJECT_SPEC,
  SPEC_ORDER
} from './constants'

import VerticalTableInput from './ConfigTable'

import FulcrumDivider from 'components/fulcrum/divider/Divider'
import {
  IconButton
} from 'react-toolbox'

class HorizontalTableConfigItem extends Component {
  generateHorizontalTableRow = () => {
    const {
      row,
      index,
      rowFormat,
      elementKey,
      onUpdate,
      onNestedAdd,
      onNestedRemove,
      onNestedUpdate
    } = this.props

    const specOrder = SPEC_ORDER[elementKey]

    return (
      <React.Fragment>
          {specOrder.map((colKey) => {
              const { type, sources } = rowFormat[colKey]
              const key = `mp${index}${colKey}`
              const title = T.translate(`${PROJECT_SPEC}.${elementKey}.item.${colKey}`)
              const onChange = onUpdate.bind(this, index, colKey)
              const val = row[colKey] || ''

              switch(type) {
                case 'string': return (
                  <FormTitle key={key} title={title}>
                    <Input
                      value={val}
                      onChange={onChange}
                      type={'string'}
                    />
                  </FormTitle>
                )
                case 'number': return (
                  <FormTitle key={key} title={title}>
                    <Input
                      value={val}
                      onChange={onChange}
                      type={'number'}
                    />
                  </FormTitle>
                )
                case 'drop_down': return (
                  <FormTitle key={key} title={title}>
                    <Dropdown
                      source={sources}
                      value={val}
                      onChange={onChange}
                    />
                  </FormTitle>
                )
                case 'array': {
                  return (
                    <VerticalTableInput
                      title={title}
                      values={row[colKey] || []}
                      rowFormat={sources}
                      elementKey={elementKey}
                      parentColKey={colKey}
                      onChange={onNestedUpdate.bind(this, index, colKey)}
                      onRemove={onNestedRemove.bind(this, index, colKey)}
                      onAdd={onNestedAdd.bind(this, colKey, index)}
                    />
                  )
                }
              }
            })}
      </React.Fragment>
    )
  }

  getTableRowCellsDel = (idx) => {
    const {
      onRemove
    } = this.props

    return (
      <span styleName="deleteSpan">
        <IconButton styleName="deleteBtn" icon='delete' onClick={onRemove.bind(this, idx)} primary />
      </span>
    )
  }

  render() {
    const {
      index
    } = this.props

    return (
      <div>
        <div>
          {this.getTableRowCellsDel(index)}
        </div>
        {this.generateHorizontalTableRow()}
        <FulcrumDivider />
      </div>
    )
  }
}

export default CSSModules(HorizontalTableConfigItem, styles)
